<template>
  <div class="cell position" :class="'cell__' + column">
    <template v-if="column === 'worker'">
      <div class="position__name">
        <c-button2
          :id="'add-workers-' + position.code"
          class="position__add-workers"
          size="small"
          :icon="{
            icon: 'plus-bold',
            color: 'primary',
          }"
          @click="$emit('addWorkers')"
        />
        <b-popover placement="top" triggers="hover" :target="'add-workers-' + position.code">
          Добавить сотрудников
        </b-popover>
        {{ position.name }}
      </div>
    </template>
    <template v-if="column === 'totalShifts'">
      <div class="shifts">
        <div v-if="data.dayShiftsCount || data.calcDayShiftsCount">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9 5.99976C9 7.65661 7.65685 8.99976 6 8.99976M9 5.99976C9 4.3429 7.65685 2.99976 6 2.99976M9 5.99976H11M6 8.99976C4.34315 8.99976 3 7.65661 3 5.99976M6 8.99976V10.9998M3 5.99976C3 4.3429 4.34315 2.99976 6 2.99976M3 5.99976H1M6 2.99976V0.999756M8.5 3.49976L9.53555 2.46421M2.46448 9.53528L3.50003 8.49973M3.50003 3.49976L2.46449 2.46421M9.53555 9.53528L8.5 8.49973"
              stroke="#BFC9E0"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
          {{ data.dayShiftsCount }}/{{ data.calcDayShiftsCount }}
        </div>
        <div v-if="data.nightShiftsCount || data.calcNightShiftsCount">
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4.21206 0.999756C2.26415 1.45382 0.874839 3.22915 1.00894 5.24767C1.07574 6.25324 1.37442 7.05834 2.15788 7.84182C2.94136 8.62532 3.74651 8.92401 4.75209 8.99082C6.77061 9.12492 8.54593 7.7356 9 5.7877C7.63077 6.11214 6.1456 6.09475 5.02529 4.97442C3.90499 3.85409 3.88761 2.36899 4.21206 0.999756Z"
              stroke="#BFC9E0"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          {{ data.nightShiftsCount }}/{{ data.calcNightShiftsCount }}
        </div>
        <div
          v-if="!data.dayShiftsCount && !data.nightShiftsCount && !data.calcDayShiftsCount && !data.nightShiftsCount"
        >
          0
        </div>
      </div>
    </template>

    <template v-if="column === 'workTime'">
      <div class="work-time">
        <div>{{ formatTime(data.totalTimeMin) }}</div>
        <div>{{ formatTime(data.calcTotalTimeMin) }}</div>
      </div>
    </template>

    <template v-if="column === 'compensation'">
      {{ (data.compensation || 0).toLocaleString() }}
    </template>

    <template v-if="column === 'load'">
      {{ (data.load || 0).toLocaleString() }}
    </template>

    <template v-if="column === 'salary'">
      {{ (data.salary || 0).toLocaleString() }}
    </template>

    <template v-if="column === 'salaryMainPart'">
      <div class="salary-main">
        <div>{{ Math.floor(data.salaryMain || 0).toLocaleString() }}</div>
        <div>{{ Math.floor(data.calcSalaryMain || 0).toLocaleString() }}</div>
      </div>
    </template>

    <template v-if="column === 'excessPremium'">
      {{ (data.excessPremium || 0).toLocaleString() }}
    </template>

    <template v-if="column === 'Depreciation'">
      {{ (data.depreciation || 0).toLocaleString() }}
    </template>

    <template v-if="column === 'premium'">
      {{ (data.premium || 0).toLocaleString() }}
    </template>

    <template v-if="column === 'fine'">
      {{ (data.fine || 0).toLocaleString() }}
    </template>

    <template v-if="column === 'penalties'">
      {{ (data.penalties || 0).toLocaleString() }}
    </template>

    <template v-if="column === 'totalAccrued'">
      {{ (data.totalAccrued || 0).toLocaleString() }}
    </template>
  </div>
</template>

<script>
import CButton2 from "@/components/controls2/Button";

export default {
  components: {
    CButton2,
  },
  props: ["column", "position", "data"],
  computed: {},

  methods: {
    formatTime(min = 0) {
      let h = Math.floor(min / 60);
      let m = min % 60;

      h = `${h}`.padStart(2, "0");
      m = `${m}`.padStart(2, "0");

      return `${h}:${m}`;
    },
  },
};
</script>
<style scoped lang="scss">
@import "~@/assets/styles/vars";
.cell {
  display: flex;
}
.position {
  background: #f5f7fa;

  &__name {
    font-size: 13px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    line-height: 1.2;
  }

  &__add-workers {
    background: white;
    width: 22px !important;
    height: 22px !important;
    margin-right: 10px;

    & /deep/ svg {
      width: 12px;
      height: 12px;
      margin-top: 1px;
      margin-left: 1px;
    }
  }
}
</style>
